/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function normaliseText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isFaqHeading(element) {
    return /^h[2-4]$/i.test(element.tagName) && /^(frequently asked questions|faqs?|common questions)$/.test(normaliseText(element.textContent));
  }

  function enhanceCollectionFaqs() {
    var descriptions = document.querySelectorAll('.collection__description--after-products .rte');

    descriptions.forEach(function (description) {
      if (description.getAttribute('data-faq-enhanced') === 'true') {
        return;
      }

      description.setAttribute('data-faq-enhanced', 'true');

      var existingDetails = description.querySelectorAll('details');
      existingDetails.forEach(function (details) {
        details.classList.add('collection-faq__item');

        var summary = details.querySelector('summary');
        if (summary) {
          summary.classList.add('collection-faq__question');
        }
      });

      var faqHeading = Array.prototype.slice.call(description.children).find(isFaqHeading);
      if (!faqHeading) {
        return;
      }

      faqHeading.classList.add('collection-faq__heading');

      var accordion = document.createElement('div');
      accordion.className = 'collection-faq';
      faqHeading.insertAdjacentElement('afterend', accordion);

      var node = accordion.nextElementSibling;

      while (node) {
        if (/^h2$/i.test(node.tagName) && !isFaqHeading(node)) {
          break;
        }

        if (/^h[3-4]$/i.test(node.tagName)) {
          var details = document.createElement('details');
          details.className = 'collection-faq__item';

          var summary = document.createElement('summary');
          summary.className = 'collection-faq__question';
          summary.textContent = node.textContent.trim();

          var answer = document.createElement('div');
          answer.className = 'collection-faq__answer rte';

          var next = node.nextElementSibling;
          node.remove();

          while (next && !/^h[2-4]$/i.test(next.tagName)) {
            var answerNode = next;
            next = next.nextElementSibling;
            answer.appendChild(answerNode);
          }

          details.appendChild(summary);
          details.appendChild(answer);
          accordion.appendChild(details);
          node = next;
        } else {
          var current = node;
          node = node.nextElementSibling;
          accordion.appendChild(current);
        }
      }

      if (!accordion.querySelector('details')) {
        accordion.remove();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCollectionFaqs);
  } else {
    enhanceCollectionFaqs();
  }
})();
